//#region ../src/utils/compass-influence-mapping.ts
/**
* Everything off: the only combination that genuinely silences the compass.
* The tolerance and gate mode carry the app's own values because they are
* inert without a prior; every switch that could give the compass a say is off.
*/
function silentCompassSettings(experiments) {
	return {
		rotationPriorEnabled: false,
		coldStartOverrideEnabled: false,
		voteWeight: 0,
		trustGateMode: experiments.trustGateMode,
		pairSelectionEnabled: false,
		trustToleranceDeg: experiments.trustToleranceDeg,
		webXRConsistencyEnabled: false
	};
}
/**
* Map a 0..1 influence to the settings that produce it.
*
* Out-of-range inputs CLAMP into [0, 1] and non-finite inputs collapse to
* silence, rather than either being passed on: `setCompassVoteWeight` would
* reject them somewhere the UI cannot see, and "the compass drives with a NaN
* weight" is the worst state available. The clamp is ASYMMETRIC in effect: a
* clamped −0.5 reaches 0 and is genuinely silent, a clamped 1.5 reaches 1 -
* FULL influence, not silence.
*/
function compassSettingsFor(influence, experiments) {
	if (!Number.isFinite(influence)) return silentCompassSettings(experiments);
	const weight = Math.min(1, Math.max(0, influence));
	if (weight === 0) return silentCompassSettings(experiments);
	return {
		rotationPriorEnabled: experiments.rotationPriorEnabled,
		coldStartOverrideEnabled: !experiments.rotationPriorEnabled,
		voteWeight: weight,
		trustGateMode: experiments.trustGateMode,
		pairSelectionEnabled: experiments.pairSelectionEnabled,
		trustToleranceDeg: experiments.trustToleranceDeg,
		webXRConsistencyEnabled: experiments.webXRConsistencyEnabled
	};
}
//#endregion
export { compassSettingsFor, silentCompassSettings };
